class CampaignModel{
    constructor(){
        this.id = null;
        this.name = null;
        this.content = null;
    }
}

export default CampaignModel;